var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex mb-4" }, [
    _c(
      "div",
      { staticClass: "flex w-full" },
      [
        _vm.itemLink
          ? [
              _c(
                "div",
                {
                  staticClass:
                    "mb-1 p-3 bg-white shadow rounded-lg my-4 min-w-max w-full",
                },
                [
                  _c("div", { staticClass: "flex justify-center" }, [
                    _c("p", { staticClass: "text-lg text-center font-bold" }, [
                      _vm._v(_vm._s(_vm.itemNumber)),
                    ]),
                  ]),
                  _c(
                    "p",
                    { staticClass: "text-sm text-center font-semibold -mt-2" },
                    [_vm._v(_vm._s(_vm.itemTitle))]
                  ),
                ]
              ),
            ]
          : [
              _c(
                "div",
                {
                  staticClass:
                    "mb-1 p-3 bg-white shadow rounded-lg my-4 min-w-max justify-center w-full",
                },
                [
                  _c("div", { staticClass: "flex justify-center" }, [
                    _c("p", { staticClass: "text-lg font-bold text-center" }, [
                      _vm._v(_vm._s(_vm.itemNumber)),
                    ]),
                  ]),
                  _c(
                    "p",
                    { staticClass: "text-sm font-semibold -mt-2 text-center" },
                    [_vm._v(_vm._s(_vm.itemTitle))]
                  ),
                ]
              ),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }